<section class="address-book-entries">
  <app-con-x-table-page
    eyebrow="Adressbuch"
    eyebrowIcon="contacts"
    [title]="addressBook?.name ?? 'Kontakte'"
    description="Personen und Organisationen durchsuchen, prüfen und verwalten."
    ariaLabel="Adressbucheinträge"
    locale="de-DE"
    [data]="entries"
    [columns]="columns"
    [actions]="pageActions"
    [rowActions]="rowActions"
    [filters]="filters"
    [inspector]="inspector"
    [selectedRow]="selectedEntry"
    [rowId]="'addressBookEntryId'"
    [summaryItems]="summaryItems"
    [emptyState]="emptyState"
    [loading]="loading"
    loadingMessage="Kontakte werden geladen …"
    [errorMessage]="errorMessage"
    errorTitle="Kontakte konnten nicht geladen werden"
    retryLabel="Erneut laden"
    [searchable]="false"
    noResultsTitle="Keine passenden Kontakte"
    noResultsDescription="Ändern Sie den Suchbegriff oder den Kontakttyp."
    [refreshable]="true"
    refreshTooltip="Kontakte aktualisieren"
    (selectedRowChange)="selectedEntry = $event"
    (pageAction)="handlePageAction($event)"
    (rowAction)="handleRowAction($event)"
    (refreshRequested)="refresh()"
    (retryRequested)="refresh()">
    <div table-page-toolbar-extra class="search-tools">
      <app-address-book-search (queryChange)="searchFullText($event)"></app-address-book-search>
      <app-address-book-prefix-search (queryChange)="searchPrefix($event)"></app-address-book-prefix-search>
    </div>
  </app-con-x-table-page>
</section>
